import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import failContract from '../../../styles/svgs/failContract.svg';
import warningContract from '../../../styles/svgs/warningContract.svg';
import Loader from '../../Loaders/Loader/Loader';
import { ERROR_STATE_CONTRACT_CREATED, ERROR_STATE_VERIFIED, PROCESSING_FAILED_ERROR_CODE } from '../options';
import MainButton from '../../MUI/MainButton';

import styles from '../PaymentConfirmation.module.scss';
import useStyles from '../makeStyles';

const ErrorContent = ({
  isLoading,
  errorTitle,
  errorDescription,
  paymentError,
  tryAgain,
  errorCode,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const resolveWarningIcon = useCallback((code) => (
    [
      PROCESSING_FAILED_ERROR_CODE,
      ERROR_STATE_CONTRACT_CREATED,
      ERROR_STATE_VERIFIED,
    ].includes(code) ? warningContract : failContract),
  []);

  return (
    <div id={styles.confirmationScreen}>
      {isLoading && <Loader />}
      <div className={styles.paymentStatusBlock}>
        <img className={styles.icon} src={resolveWarningIcon(errorCode)} alt="" />
        <div>
          <div className={classes.statusTitle}>{errorTitle}</div>
          <div className={classes.subText}>{errorDescription}</div>

          <div className={classes.failButtonsSection}>
            {paymentError && tryAgain && (
            <MainButton variant="outlined" color="primary" onClick={tryAgain}>
              {t('paymentConfirmation.tryAgain')}
            </MainButton>
            )}
            <Link to="/">
              <MainButton variant={tryAgain ? 'contained' : 'outlined'} color="primary">
                {t('paymentConfirmation.finish')}
              </MainButton>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

ErrorContent.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  errorTitle: PropTypes.string.isRequired,
  errorDescription: PropTypes.string.isRequired,
  paymentError: PropTypes.bool.isRequired,
  tryAgain: PropTypes.func,
  errorCode: PropTypes.string,
};

ErrorContent.defaultProps = {
  errorCode: '',
  tryAgain: null,
};

export default ErrorContent;
